import { css } from 'styled-system/css';

export const gestureSettingModalStyles = {
	header: css({
		base: {
			'--galaxy-header-text': { base: 'var(--p500)', _dark: 'white' },
			borderBottom: '1px solid {colors.blackOpacity.12}',
			color: 'var(--galaxy-header-text)',
			w: '100%',
			'& .modalTitle': {
				minH: 'unset',
				lineHeight: '42px',
				p: '0 12px 0 12px', 
			},

			'& .modalCloseBtn': {
				top: '6px'
			}
		},
	}),
	modalContainer: css({
		maxW: '336px',
	}),
	container: css({
		bgColor: 'var(-s600)',
		p: '0px 12px 24px 12px',
		h: '100vh',
		maxH: '420px',
		display: 'flex',
		flexDir: 'column',
		alignItems: 'center',
		textAlign: 'center',
		userSelect: 'none',
		borderBottomRadius: '6px',
		md: {
			display: 'none'
		}
	}),
	topText: css({
		fontSize: '16px',
		fontWeight: '500',
		lineHeight: '18px',
		color: 'jupiter.grey.70',
		minH: '66px',
		pt: '24px',
		_active: {
			color: 'jupiter.success.100',
		},
		'&[data-error="true"]': {
			color: 'jupiter.error.100'
		}
	}),
	submitButton: css({
		w: '100%',
		borderRadius: '6px',
		minHeight: '36px',
		padding: '0 6px',
		fontSize: '14px',
		fontWeight: '700',
		border: 'none',
		cursor: 'pointer',
		maxW: '300px',
	}),
	bottom: css({
		mt: 'auto',
		display: 'flex',
		alignItems: 'center',
		flexDir: 'column',
		w: '100%'
	})
}